import { useCallback, useMemo, useState } from 'react';
import useSWR from 'swr';
import { useClient } from '../../../../hooks/useClient';
import { ExternalUserExpensesResponse, ProfileOrganization } from '../types';
import { getMonthGridRange } from '../utils';

export const useExpensesCalendar = ({
  organization,
  externalUserId,
}: {
  organization: ProfileOrganization;
  externalUserId: string | undefined;
}) => {
  const { get } = useClient();

  // State for controlled expenses calendar
  const [expensesCalendarDate, setExpensesCalendarDate] = useState<Date>(new Date());

  const expensesDateRange = useMemo(() => {
    return getMonthGridRange(expensesCalendarDate);
  }, [expensesCalendarDate]);

  const expensesUrl = useMemo(() => {
    if (!organization || !externalUserId) return null;
    const startDate = expensesDateRange.start.toISOString();
    const endDate = expensesDateRange.end.toISOString();
    return `/organizations/${organization.id}/external-users/${externalUserId}/expenses?startDate=${startDate}&endDate=${endDate}`;
  }, [organization, externalUserId, expensesDateRange]);

  const { data: userExpenses, isLoading: expensesLoading } = useSWR(expensesUrl, get<ExternalUserExpensesResponse>);

  const handleExpensesCalendarNavigate = useCallback((newDate: Date) => {
    setExpensesCalendarDate(newDate);
  }, []);

  return { expensesCalendarDate, userExpenses, expensesLoading, handleExpensesCalendarNavigate };
};
